export default __webpack_public_path__ + "static/media/Carol_Pefley.03fd5b8d.jpg";